import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTracking from './tracking';
import * as fromDataLayer from './data-layer';

export interface AnalyticsState {
  tracking: fromTracking.State;
  dataLayer: fromDataLayer.State;
}

export const reducers: ActionReducerMap<AnalyticsState> = {
  tracking: fromTracking.reducer,
  dataLayer: fromDataLayer.reducer
};

export const getAnalyticsState = createFeatureSelector<AnalyticsState>('analytics');

export const getDataLayer = createSelector(getAnalyticsState, state => state.dataLayer);
